import React from 'react'
import Expander from '../Expander'
import Text, { HeaderText } from '../Text'

export default function(notification, size = 1) {
  return (
    <Expander size={size} id={notification.id}>
      <Text size={size}>
        <HeaderText size={size}>{notification.message}</HeaderText>
        <span
          style={{ wordBreak: 'break-word' }}
          dangerouslySetInnerHTML={{ __html: notification.details.exception }}
        />
      </Text>
    </Expander>
  )
}
